import { render, staticRenderFns } from "./lactationSummary.vue?vue&type=template&id=04cc3d06&scoped=true&"
import script from "./lactationSummary.vue?vue&type=script&lang=js&"
export * from "./lactationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc3d06",
  null
  
)

export default component.exports